// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M11 16.18V5Q11 4.58 11.29 4.29T12 4 12.71 4.29 13 5V16.18L17.9 11.28Q18.2 10.98 18.6 10.99T19.3 11.3Q19.58 11.6 19.59 12T19.3 12.7L12.7 19.3Q12.55 19.45 12.37 19.51T11.99 19.57 11.61 19.51 11.28 19.3L4.68 12.7Q4.4 12.42 4.4 12.01T4.7 11.3Q5 11 5.41 11T6.12 11.3Z"/>';

/** Arrow Down (arrows). */
const icon: IconData = {
  id: "arrow-down",
  name: "Arrow Down",
  category: "arrows",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: '<path d="M11 4V16.18L5.4 10.58 4 12 12 20 20 12 18.6 10.57 13 16.17V4Z"/>' },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M11 16.18V5Q11 4.58 11.29 4.29T12 4 12.71 4.29 13 5V16.18L17.9 11.28Q18.2 10.98 18.6 10.99T19.3 11.3Q19.58 11.6 19.59 12T19.3 12.7L12.7 19.3Q12.55 19.45 12.37 19.51T11.99 19.57 11.61 19.51 11.28 19.3L4.68 12.7Q4.4 12.42 4.4 12.01T4.7 11.3Q5 11 5.41 11T6.12 11.3Z"/></g><path d="M11 16.18V5Q11 4.58 11.29 4.29T12 4 12.71 4.29 13 5V16.18L17.9 11.28Q18.2 10.98 18.6 10.99T19.3 11.3Q19.58 11.6 19.59 12T19.3 12.7L12.7 19.3Q12.55 19.45 12.37 19.51T11.99 19.57 11.61 19.51 11.28 19.3L4.68 12.7Q4.4 12.42 4.4 12.01T4.7 11.3Q5 11 5.41 11T6.12 11.3Z"/>',
    },
  },
  animation: () => import("../animations/arrow-down.js"),
};

export default icon;
